module.exports = __webpack_public_path__ + "img/AWAKEN-Landing_page-logo-verbier-days.d3bcf5c.jpg";